<template>
    <div class="tradeshow-cal-main" id="content-sidebar">
        <div class="sidebar-column">
            <div class="vert-diag">
                <h1>Tradeshow Calendar</h1>
                <div class="lines"></div><!-- lines -->
                <div class="red-diagonals"></div>
            </div><!-- vert-diag -->
        </div><!-- sidebar-column -->

        <div class="main-wrapper">
            <p>PIP® is glad to be back and once again participating at in-person industry events and tradeshows this
                year. The health and safety of our employees, as well as our customers, continue to be of the utmost
                importance as we take the necessary precautions to meet in person safely and responsibly. Below is a
                list of upcoming events that PIP® will be attending in 2023. We look forward to seeing you soon!</p>
            <div class="tradeshow-cal">
                <div>
                    <a href="https://www.fabtechexpo.com/" target="_blank"><img
                            src="/images/tradeshow/illinois-fab.jpg" /></a>
                    <h3 class="space">Fabtech</h3>
                    <p>McCormick Place</p>
                    <p>Chicago, IL<br /><strong>September 11 - September 14, 2023</strong><br />
                        <a href="https://www.fabtechexpo.com/" target="_blank"></a>
                    </p>
                </div>
                <div>
                    <a href="https://www.theutilityexpo.com/" target="_blank"><img
                            src="/images/tradeshow/kentucky.jpg" /></a>
                    <h3 class="space">ICUEE</h3>
                    <p>Kentucky Exposition Center</p>
                    <p>Louisville, KY<br /><strong>September 26 - September 28, 2023</strong><br />
                        <a href="https://www.theutilityexpo.com/" target="_blank"></a>
                    </p>
                </div>
                <div>
                    <a href="https://congress.nsc.org/nsc2022/public/enter.aspx" target="_blank"><img
                            src="/images/tradeshow/neworleans.jpg" /></a>
                    <h3 class="space">NSC Safety Congress & Expo</h3>
                    <p>Ernest N. Morial Convention Center</p>
                    <p>New Orleans, LA<br /><strong>October 20 - October 26, 2023</strong><br />
                        <a href="https://congress.nsc.org/nsc2022/public/enter.aspx" target="_blank"></a>
                    </p>
                </div>
                <div>
                    <a href="https://www.glassbuildamerica.com/future-dates" target="_blank"><img
                            src="/images/tradeshow/georgia.jpg" /></a>
                    <h3 class="space">GLASSBUILD</h3>
                    <!-- <p>Location Pending???</p> -->
                    <p>Atlanta, GA<br /><strong>October 31 - November 2, 2023</strong><br />
                        <a href="https://www.glassbuildamerica.com/future-dates" target="_blank"></a>
                    </p>
                </div>
            </div> <!-- tradeshow-cal-wrap -->
        </div>
        <!-- main-wrapper -->
    </div>
</template>

<script>
const months = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12,
}

$(document).ready(function () {
    var dateData = new Date();
    var month = dateData.toLocaleString('default', { month: 'long' });
    var day = dateData.getDate();
    var year = dateData.getFullYear();

    //Grab all dates and loop through them
    $('.tradeshow-cal > div strong').each(function (index) {

        //Parse the text into something we can use
        var tradeShowDate = $(this).text().split(',');
        //First, check to see if the year of the tradeshow is before the current year. If it isn't, definitely don't display it;
        if ((tradeShowDate[1].trim()) < year) {
            $(this).parent().parent().css("display", "none");
        } else {
            //Check the month, which will always be the second to last index
            var tradeShowDateRange = tradeShowDate[0].split(' ');
            tradeShowMonth = tradeShowDateRange[tradeShowDateRange.length - 2];
            //Check if the month has already passed
            if (months[tradeShowMonth.toLowerCase()] < months[month.toLowerCase()]) {
                $(this).parent().parent().css("display", "none");
            } else {
                //Check the day and see how it compares, but only if the months are the same
                if (months[tradeShowMonth.toLowerCase()] == months[month.toLowerCase()]) {
                    var tradeShowDay = tradeShowDateRange[tradeShowDateRange.length - 1];
                    if (tradeShowDay < day) {
                        $(this).parent().parent().css("display", "none");
                    }
                }
            }
        }
    });
});
</script>
